import React from "react";
import "./InfoSlide.css";

interface InfoSlideProps {
  text: string;
}

const repeatCount = 8; // Adjust as needed for your banner width

const InfoSlide: React.FC<InfoSlideProps> = ({ text }) => (
  <div className="info-slide-banner">
    <div className="info-slide-track">
      {Array.from({ length: repeatCount }).map((_, i) => (
        <span className="info-slide-text" key={i}>
          {text}
        </span>
      ))}
    </div>
  </div>
);

export default InfoSlide;
